const types = {
	GET_BUILDING_DETAILS_START: "GET_BUILDING_DETAILS_START",
	GET_BUILDING_DETAILS_SUCCESS: "GET_BUILDING_DETAILS_SUCCESS",
	GET_BUILDING_DETAILS_ERROR: "GET_BUILDING_DETAILS_ERROR",
};

export default types;
